import React from "react"
import Layout from "../components/Layout"
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component"
import "react-vertical-timeline-component/style.min.css"
import * as styles from "../styles/experience.module.css"
import { graphql } from "gatsby"

export default function ExperiencePage({ data }) {
  // console.log(data)
  const experienceList = data.allMongodbMyPortfolioExperience.nodes
  return (
    <Layout>
      <div className={styles.experience}>
        <h1>Experience</h1>
        <VerticalTimeline>
          {experienceList &&
            experienceList.length > 0 &&
            experienceList.map(experence => {
              const date = `${new Date(experence.startDate)
                .getFullYear()
                .toString()} - ${
                experence.currentlyWorking
                  ? "Present"
                  : new Date(experence.endDate).getFullYear().toString()
              }`
              return (
                <VerticalTimelineElement
                  key={experence.mongodb_id}
                  className="vertical-timeline-element--work"
                  contentStyle={{
                    background: "rgb(33, 150, 243)",
                    color: "#fff",
                  }}
                  contentArrowStyle={{
                    borderRight: "7px solid  rgb(33, 150, 243)",
                  }}
                  date={date}
                  iconStyle={{
                    background: "rgb(33, 150, 243)",
                    color: "#fff",
                  }}
                >
                  <h3 className="vertical-timeline-element-title">
                    {experence.resignation},
                  </h3>
                  <h3 className="vertical-timeline-element-title">
                    {experence.companyName}
                  </h3>
                  <h4 className="vertical-timeline-element-subtitle">
                    {experence.city}, {experence.country}
                  </h4>
                  <p>{experence.description}</p>
                </VerticalTimelineElement>
              )
            })}
        </VerticalTimeline>
      </div>
    </Layout>
  )
}

export const query = graphql`
  query Experience {
    allMongodbMyPortfolioExperience {
      nodes {
        startDate
        resignation
        mongodb_id
        jobType
        endDate
        description
        currentlyWorking
        country
        companyName
        city
      }
    }
  }
`
